module.exports = __webpack_public_path__ + "static/img/42.5669be0f.png";